module.exports = Jsw.skinUrl + "/images/disco-mode/logo.svg?4682fd3a1648d22360d0de4f47aab3db";